(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_sb-detail-tab"] && !Shopify.designMode) return;
  try {
    (function() {
    function initAudioPlayers() {
        // Initialize audio players
      document.querySelectorAll('._sb-detail-tab__audio-player').forEach(function(player) {
        const btn = player.querySelector('._sb-detail-tab__audio-play-btn');
        const audio = player.querySelector('._sb-detail-tab__audio-element');
        const progressBar = player.querySelector('._sb-detail-tab__audio-progress-bar');
        const timeDisplay = player.querySelector('._sb-detail-tab__audio-time');

        if (!btn || !audio || !progressBar) return;

        // Format time helper function
        function formatTime(seconds) {
          if (!isFinite(seconds) || isNaN(seconds)) return '00:00';
          const mins = Math.floor(seconds / 60);
          const secs = Math.floor(seconds % 60);
          return String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0');
        }

        // Update time display
        function updateTimeDisplay() {
          if (timeDisplay && audio.duration) {
            const current = formatTime(audio.currentTime || 0);
            const total = formatTime(audio.duration || 0);
            timeDisplay.textContent = current + '/' + total;
          }
        }
        
        // Skip if already initialized
        if (btn.dataset.initialized === 'true') return;
        btn.dataset.initialized = 'true';

        // Play/Pause toggle
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          if (audio.paused) {
            // Pause all other audio players
            document.querySelectorAll('._sb-detail-tab__audio-element').forEach(function(otherAudio) {
              if (otherAudio !== audio && !otherAudio.paused) {
                otherAudio.pause();
                const otherPlayer = otherAudio.closest('._sb-detail-tab__audio-player');
                if (otherPlayer) {
                  const otherBtn = otherPlayer.querySelector('._sb-detail-tab__audio-play-btn');
                  if (otherBtn) otherBtn.classList.remove('is-playing');
                }
              }
            });

            audio.play().then(function() {
              btn.classList.add('is-playing');
            }).catch(function(error) {
              console.error('Audio play failed:', error);
            });
          } else {
            audio.pause();
            btn.classList.remove('is-playing');
          }
        });

        // Update progress bar and time display
        audio.addEventListener('timeupdate', function() {
          if (audio.duration) {
            const progress = (audio.currentTime / audio.duration) * 100;
            progressBar.style.width = progress + '%';
            updateTimeDisplay();
          }
        });

        // Update time display when metadata is loaded
        audio.addEventListener('loadedmetadata', function() {
          updateTimeDisplay();
        });

        // Reset button when audio ends
        audio.addEventListener('ended', function() {
          btn.classList.remove('is-playing');
          progressBar.style.width = '0%';
          updateTimeDisplay();
        });

        // Handle audio loading errors
        audio.addEventListener('error', function(e) {
          console.error('Audio loading error:', e);
        });

        // Click on progress bar to seek
        const progressContainer = player.querySelector('._sb-detail-tab__audio-progress');
        if (progressContainer) {
          progressContainer.addEventListener('click', function(e) {
            if (audio.duration) {
              const rect = progressContainer.getBoundingClientRect();
              const percent = (e.clientX - rect.left) / rect.width;
              audio.currentTime = percent * audio.duration;
            }
          });

          progressContainer.style.cursor = 'pointer';
        }
      });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAudioPlayers);
    } else {
      initAudioPlayers();
    }

    // Also initialize after a short delay to catch dynamically loaded content
    setTimeout(initAudioPlayers, 500);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_sb-faq"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sb-faq')) {
    class SbFaq extends HTMLElement {
      constructor() {
        super();
        this.buttons = [];
        this.contents = [];
      }

      connectedCallback() {
        try {
          this.init();
        } catch (error) {
          console.error('[sb-faq] Initialization error:', error);
        }
      }

      init() {
        this.buttons = Array.from(this.querySelectorAll('.sb-faq--slider ._faq-category__tab-button'));
        this.contents = Array.from(this.querySelectorAll('._sb-faq__content ._faq-category__content'));

        if (this.buttons.length === 0) return;

        this.setupAriaRelationships();
        this.setupEventListeners();
        this.activateTab(this.buttons[0]);
      }

      /**
       * Dynamically assigns unique IDs and ARIA relationships.
       * This is necessary because the _faq-category block is rendered twice
       * (once in slider, once in content area) via captured block_contents.
       * Static IDs would cause duplicates and break ARIA relationships.
       */
      setupAriaRelationships() {
        this.buttons.forEach((button, index) => {
          const blockId = button.dataset.blockId;
          const tabId = `FaqTab-${blockId}`;
          const panelId = `FaqPanel-${blockId}`;

          /* Set unique ID on the slider tab button */
          button.id = tabId;
          button.setAttribute('aria-controls', panelId);

          /* Find the matching content panel and set its ID */
          const matchingContent = this.contents.find((content) => content.dataset.blockId === blockId);

          if (matchingContent) {
            matchingContent.id = panelId;
            matchingContent.setAttribute('aria-labelledby', tabId);
          }
        });
      }

      setupEventListeners() {
        this.addEventListener('click', this.handleClick.bind(this));
        this.addEventListener('keydown', this.handleKeydown.bind(this));
      }

      handleClick(event) {
        const button = event.target.closest('._faq-category__tab-button');
        if (!button || !this.buttons.includes(button)) return;

        this.activateTab(button);
      }

      handleKeydown(event) {
        const button = event.target.closest('._faq-category__tab-button');
        if (!button || !this.buttons.includes(button)) return;

        const currentIndex = this.buttons.indexOf(button);
        let newIndex = currentIndex;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            event.preventDefault();
            newIndex = (currentIndex + 1) % this.buttons.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            event.preventDefault();
            newIndex = (currentIndex - 1 + this.buttons.length) % this.buttons.length;
            break;
          case 'Home':
            event.preventDefault();
            newIndex = 0;
            break;
          case 'End':
            event.preventDefault();
            newIndex = this.buttons.length - 1;
            break;
          case 'Enter':
          case ' ':
            event.preventDefault();
            this.activateTab(button);
            return;
          default:
            return;
        }

        this.buttons[newIndex].focus();
        this.activateTab(this.buttons[newIndex]);
      }

      activateTab(button) {
        const tabConnection = button.dataset.tabConnection;
        if (!tabConnection) return;

        /* Update visual states */
        this.buttons.forEach((btn) => btn.classList.remove('active'));
        this.contents.forEach((content) => content.classList.remove('active'));

        button.classList.add('active');

        /* Update ARIA states and tabindex for roving tabindex pattern */
        this.buttons.forEach((btn) => {
          const isActive = btn === button;
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
          btn.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        /* Show/hide panels and update active states */
        this.contents.forEach((content) => {
          const isActive = content.dataset.tabConnection === tabConnection;
          content.classList.toggle('active', isActive);
          if (isActive) {
            content.removeAttribute('hidden');
          } else {
            content.setAttribute('hidden', '');
          }
        });
      }
    }

    customElements.define('sb-faq', SbFaq);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_sb-featured-collection"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sb-featured-collection')) {
    class SbFeaturedCollection extends HTMLElement {
      constructor() {
        super();
        this.modal = this;
        this.toggleButtonHandlers = [];
        this.closeOtherModalsHandler = this.handleCloseOtherModals.bind(this);
      }
  
      connectedCallback() {
        try {
          this.initializeToggleButtons();
          this.initializeModalCloseListener();
        } catch (error) {
          console.error('[SbFeaturedCollection] Initialization error:', error);
        }
      }

      initializeToggleButtons() {
        // Find toggle button inside the modal
        const internalToggle = this.querySelector('._sb-featured-collection__modal-toggle');
        
        // Find toggle button outside the modal (sibling)
        const card = this.closest('._sb-featured-collection__card');
        const externalToggle = card ? card.querySelector(':scope > ._sb-featured-collection__modal-toggle') : null;

        // Store references to both buttons and their handlers
        const buttons = [internalToggle, externalToggle].filter(Boolean);
        
        buttons.forEach(button => {
          const handler = () => this.toggleModal();
          button.addEventListener('click', handler);
          this.toggleButtonHandlers.push({ button, handler });
        });
      }

      initializeModalCloseListener() {
        // Listen for events from other modals to close this one
        document.addEventListener('sb-featured-collection:open', this.closeOtherModalsHandler);
      }

      isTabletOrHigher() {
        return window.matchMedia('(min-width: 767px)').matches;
      }

      toggleModal() {
        const willBeActive = !this.modal.classList.contains('active');
        
        // On tablet and higher, handle scroll before opening
        if (this.isTabletOrHigher() && willBeActive) {
          // Emit scroll request event before opening
          document.dispatchEvent(new CustomEvent('sb-featured-collection:scroll-request', {
            detail: { source: this }
          }));
          
          // Wait for scroll animation to complete before toggling
          setTimeout(() => {
            this.completeToggle(willBeActive);
          }, 450);
        } else {
          // For closing or on mobile, toggle immediately
          this.completeToggle(willBeActive);
        }
      }

      completeToggle(willBeActive) {
        this.modal.classList.toggle('active');
        
        // Emit events on tablet and higher
        if (this.isTabletOrHigher()) {
          // Emit toggle event for slider dimension updates
          document.dispatchEvent(new CustomEvent('sb-featured-collection:toggle', {
            detail: { source: this, isOpening: willBeActive }
          }));
          
          // Emit open event when opening for closing other modals
          if (willBeActive) {
            document.dispatchEvent(new CustomEvent('sb-featured-collection:open', {
              detail: { source: this }
            }));
          }
        }
      }

      handleCloseOtherModals(event) {
        // Close this modal if it's not the one that was just opened
        if (event.detail.source !== this && this.modal.classList.contains('active')) {
          this.modal.classList.remove('active');
          
          // Emit toggle event when closed by another modal opening
          if (this.isTabletOrHigher()) {
            document.dispatchEvent(new CustomEvent('sb-featured-collection:toggle', {
              detail: { source: this, isOpening: false }
            }));
          }
        }
      }

      disconnectedCallback() {
        // Remove all event listeners
        this.toggleButtonHandlers.forEach(({ button, handler }) => {
          button.removeEventListener('click', handler);
        });
        this.toggleButtonHandlers = [];
        
        // Remove modal close listener
        document.removeEventListener('sb-featured-collection:open', this.closeOtherModalsHandler);
      }
    }
  
    customElements.define('sb-featured-collection', SbFeaturedCollection);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_sb-featured-items-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-height-sync')) {
    /**
     * TdHeightSync Web Component
     * 
     * Synchronizes the height of the feature image with the swiper slides.
     * Listens for swiper initialization and window resize events to keep heights in sync.
     */
    class TdHeightSync extends HTMLElement {
      constructor() {
        super();
        this.featureImage = null;
        this.resizeTimeout = null;
        this.DESKTOP_BREAKPOINT = 1024;
        this.RESIZE_DEBOUNCE_MS = 150;
      }

      connectedCallback() {
        try {
          this.featureImage = this.querySelector('.td-featured-items__image');
          if (!this.featureImage) return;

          this.handleSwiperInit = this.handleSwiperInit.bind(this);
          this.handleResize = this.handleResize.bind(this);

          this.addEventListener('swiper:init', this.handleSwiperInit);
          window.addEventListener('resize', this.handleResize);
        } catch (error) {
          console.error('[TdHeightSync] Initialization error:', error);
        }
      }

      disconnectedCallback() {
        this.removeEventListener('swiper:init', this.handleSwiperInit);
        window.removeEventListener('resize', this.handleResize);
        if (this.resizeTimeout) {
          clearTimeout(this.resizeTimeout);
        }
      }

      /**
       * Handles the swiper:init event to sync heights after swiper is ready
       */
      handleSwiperInit() {
        this.syncHeight();
      }

      /**
       * Handles window resize with debouncing for performance
       */
      handleResize() {
        if (this.resizeTimeout) {
          clearTimeout(this.resizeTimeout);
        }
        this.resizeTimeout = setTimeout(() => {
          this.syncHeight();
        }, this.RESIZE_DEBOUNCE_MS);
      }

      /**
       * Syncs the feature image height to match the swiper slide height.
       * Only applies on desktop where the feature image is visible.
       */
      syncHeight() {
        if (!this.featureImage) return;

        // Only sync on desktop - feature image is hidden on mobile via CSS
        if (window.innerWidth < this.DESKTOP_BREAKPOINT) {
          this.featureImage.style.height = '';
          return;
        }

        const slide = this.querySelector('.swiper-slide');
        if (!slide) return;

        const slideHeight = slide.offsetHeight;
        if (slideHeight > 0) {
          this.featureImage.style.height = `${slideHeight}px`;
        }
      }
    }

    customElements.define('td-height-sync', TdHeightSync);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["page-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
    const trigger = event.target.closest('.open_faq, .open_faq_3');

    if (trigger) {
      const faqIcon = trigger.querySelector(".faq_icon");
      if (faqIcon) {
          faqIcon.classList.toggle("faq_icon_open");
      }
      const contentPanel = trigger.nextElementSibling;
      
      if (contentPanel) {
          contentPanel.classList.toggle("swiper-slide-open");
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    (function() {
    const ratingWrappers = document.querySelectorAll('[data-scroll-to-reviews="true"]');
    if (ratingWrappers.length === 0) return;

    const scrollToReviews = (e) => {
      if (e.type === 'keydown' && !['Enter', ' '].includes(e.key)) return;
      e.preventDefault();

      const target = document.querySelector('#judgeme_product_reviews');
      if (!target) return;

      const header = document.querySelector('header-component, header, .section-header');
      const offset = header?.offsetHeight || 0;
      const topPosition = target.getBoundingClientRect().top + window.scrollY - offset;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: topPosition,
        behavior: reduceMotion ? 'instant' : 'smooth'
      });

      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    };

    ratingWrappers.forEach((ratingWrapper) => {
      ratingWrapper.addEventListener('click', scrollToReviews);
      ratingWrapper.addEventListener('keydown', scrollToReviews);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["td-coupon-image-box"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-coupon-image-box')) {
    const VISIBLE_MS = 1800;
    const DEBOUNCE_MS = 600;
    let popupEl = null;
    let hideTimer = null;
    let lastClickAt = 0;
    let inFlight = false;

    function ensurePopup() {
      if (popupEl && document.body.contains(popupEl)) return popupEl;
      popupEl = document.createElement('div');
      popupEl.className = 'td-coupon-image-box__global-popup';
      popupEl.setAttribute('role', 'status');
      popupEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(popupEl);
      return popupEl;
    }

    function showPopup(label, bg, color) {
      const el = ensurePopup();
      el.textContent = label;
      if (bg) el.style.setProperty('--td-coupon-popup-bg', bg);
      if (color) el.style.setProperty('--td-coupon-popup-color', color);
      // Re-trigger transition if popup is already visible
      if (el.classList.contains('is-visible')) {
        el.classList.remove('is-visible');
        void el.offsetWidth;
      }
      el.classList.add('is-visible');
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(() => el.classList.remove('is-visible'), VISIBLE_MS);
    }

    class TdCouponImageBox extends HTMLElement {
      connectedCallback() {
        const trigger = this.querySelector('.td-coupon-image-box__trigger');
        if (!trigger) return;
        if (!this.dataset.code) return;
        if (trigger.tagName.toLowerCase() !== 'button') return;

        this._onClick = this._onClick.bind(this);
        trigger.addEventListener('click', this._onClick);
      }

      _onClick(event) {
        event.preventDefault();
        const now = Date.now();
        if (inFlight) return;
        if (now - lastClickAt < DEBOUNCE_MS) return;
        lastClickAt = now;
        this.copyCode();
      }

      copyCode() {
        const code = this.dataset.code;
        if (!code) return;
        inFlight = true;
        const done = () => { inFlight = false; };

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code)
            .then(() => { this._feedback(); })
            .catch(() => { this._fallbackCopy(code); })
            .finally(done);
        } else {
          try { this._fallbackCopy(code); } finally { done(); }
        }
      }

      _fallbackCopy(text) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-9999px';
        textArea.style.top = '-9999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          this._feedback();
        } catch (err) {
          console.error('td-coupon-image-box: copy failed', err);
        }
        document.body.removeChild(textArea);
      }

      _feedback() {
        const label = this.dataset.copiedLabel || 'Copied!';
        const styles = getComputedStyle(this);
        const bg = styles.getPropertyValue('--td-coupon-popup-bg').trim();
        const color = styles.getPropertyValue('--td-coupon-popup-color').trim();
        showPopup(label, bg, color);
      }
    }
    customElements.define('td-coupon-image-box', TdCouponImageBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["td-discount-code"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('td-discount-code')) {
  class TdDiscountCode extends HTMLElement {
    constructor() {
      super();
      this.copiedStateDuration = 2000;
    }

    connectedCallback() {
      const containers = this.querySelectorAll('.td-discount-code__container');
      
      if (!containers.length) {
        return;
      }
      
      containers.forEach((container) => {
        container.addEventListener('click', this.copyDiscountCode.bind(this));
      });
    }
    
    copyDiscountCode(event) {
      const container = event.currentTarget;
      const promoCode = container.getAttribute('data-code');
      
      if (!promoCode) {
        return;
      }
      
      // Use the modern Clipboard API if available
      if (navigator.clipboard) {
        navigator.clipboard.writeText(promoCode).then(() => {
          this.showCopyFeedback(container);
        }).catch((err) => {
          // Fallback for clipboard API failure
          this.fallbackCopyTextToClipboard(promoCode, container);
        });
      } else {
        // Fallback for older browsers
        this.fallbackCopyTextToClipboard(promoCode, container);
      }
    }
    
    fallbackCopyTextToClipboard(text, container) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        document.execCommand('copy');
        this.showCopyFeedback(container);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
      
      document.body.removeChild(textArea);
    }
    
    showCopyFeedback(container) {
      // Show "Copied!" in container
      container.classList.add('copied');
      setTimeout(() => {
        container.classList.remove('copied');
      }, this.copiedStateDuration);
    }
  }
  customElements.define('td-discount-code', TdDiscountCode);
}
  } catch(e) { console.error(e); }
})();

})();
